// import React from 'react'

// const HomeResponsive = () => {
//   return (<>



// <nav className="navbar">



//     <h1 className="logo">Styling</h1>

//     <ul className="nav-links">

//         <li className="active">
//             <a href="#">Home</a>
//         </li>

//         <li>
//             <a href="#">Tours</a>
//         </li>

//         <li>
//             <a href="#">Explore</a>
//         </li>

//         <li>
//             <a href="#">About</a>
//         </li>

//         <li className="ctn">
//             <a href="#">Contact</a>
//         </li>

//     </ul>

//     <img src="../Portfolio/src/assets/img/3d-gold.jpg" alt="hex" className="menu-btn"/>

// </nav>




// <header>

// <div className="header-content">


//     <h2>Explore My Portfolio</h2>

//     <div className="line"></div>

//     <h1>A Responsive Portfolio</h1>
//     <a href="#" className="ctn">Learn More</a>

//     </div>



// </header>



// <section className="events">
//     <div className="title">
//         <h1>Artificial Intelligence Meets The Man</h1>
//         <div className="line"></div>
//     </div>



//     <div className="row">
//         <div className="col">
//             <img src="../Portfolio/src/assets/img/bear.jpeg" alt="hex"/>
//             <h4>Mount Bear Render</h4>
//             <p>Rendered with AI</p>
//             <a href="#" className="ctn">Learn the Prompt</a>
//         </div>

//         <div className="col">

//             <img src="../Portfolio/src/assets/img/dark-black-cloaked-hooded-anthropomorphic-wolf-cult-r (3).jpg" alt="wolf"/>
//             <h4>Wolfing Out</h4>
//             <p>Similar to a 'Wednesday' event</p>
//             <a href="#" className="ctn">Learn the Prompt</a>
//         </div>
//     </div>
// </section>




// <section className="explore">

// <div className="explore-content">
//     <h1>Explore The World of Technology</h1>
//     <div className="line"></div>
//     <p>AI is taking over</p>
//     <a href="#" className="ctn">Learn More</a>
// </div>
// </section>



// <section className="tours">


//     <div className="row">


//         <div className="col content-col">


//                 <h1>Trials and Tribulations</h1>
//                 <div className="line"></div>
//                 <p>What I have learned so far.....</p>
//                 <a href="#" className="ctn">Learn More</a>


//         </div>


//         <div className="col image-col">
            
//             <div className="image-gallery">

// <img src="../Portfolio/src/assets/img/tea.png" alt=""/>
// <img src="../Portfolio/src/assets/img/wood.jpg" alt=""/>
// <img src="../Portfolio/src/assets/img/dark-black-cloaked-hooded-anthropomorphic-wolf-cult-r.jpg" alt=""/>
// <img src="../Portfolio/src/assets/img/sticker.png" alt=""/>
// <img src="../Portfolio/src/assets/img/dark-black-cloaked-hooded-anthropomorphic-wolf-cult-r (4).jpg" alt=""/>
// <img src="../Portfolio/src/assets/img/fisher-price-see-and-say-with-mickey-mouse-95ef5d.jpg" alt=""/>


//             </div>


//         </div>
//     </div>



// </section>








// <section className="footer">

//     <p>Champaign, Illinois </p>
//     <p>Local 243 United Brotherhood of Carpenters</p>





// </section>


//   </>)
// }

// export default HomeResponsive

import React from 'react'

const HomeResponsive = () => {
  return (
    <div>HomeResponsive</div>
  )
}

export default HomeResponsive